import { Component, OnInit } from "@angular/core";
import { RedirectService } from "@pwc-bei/common";
import { SamlLoginService } from "src/app/components/saml-login/service/saml-login.service";
import { LoginErrorEnum } from "src/app/enums/saml-login/login-error.enum";
import { LoginMessagesEnum } from "src/app/enums/saml-login/login-messages.enum";
import { environment } from "src/environments/environment";
import { SAMLJwtCredentials } from "../models/saml-jwt-credentials";
import { ActivatedRoute, Router } from "@angular/router";
import { RoutePath } from "src/app/enums/route-path.enum";

@Component({
    selector: "app-saml-login",
    templateUrl: "./saml-login.component.html",
    styleUrls: ["./saml-login.component.scss"],
    standalone: false
})
export class SamlLoginComponent implements OnInit {
  readonly samlUrl: string = environment.samlUrl;
  readonly meUrl: string = environment.meUrl;
  readonly baseHref = environment.baseHref;
  readonly directChannel = environment.directChannel;

  private token: string;

  message: string = LoginMessagesEnum.AUTHENTICATION;
  error: boolean = false;
  concurrentLogin: boolean = false;

   private hasSamlError: boolean = false;  

  constructor(
    private samlLoginService: SamlLoginService,
    private redirectService: RedirectService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Controlla se siamo nella fase 2 (post-redirect dal SAML)
    this.hasSamlError = this.route.snapshot.queryParams['result'] === 'error';

    if(this.hasSamlError) {
        this.onMysteriousError("authenticate", "SAMLAuthentication Failed");
    } else {
      this.samlLoginService.isAuthenticated().subscribe(
        (isAuthenticated: boolean) => {
          if (isAuthenticated) {
            this.message = LoginMessagesEnum.AUTHENTICATION_ALREADY;
            this.navigateAfterTimeout(this.meUrl);
          } else {
            this.authenticate();
          }
        }
      )
    }
  }

  /**
   * Requests a login token throught the login service,
   * return an error if the user is not authenticated
   */
  private authenticate(): void {
    this.samlLoginService.samlAuthRequest().subscribe(
      (response: SAMLJwtCredentials) => {
        this.token = response.samlToken;
        this.exchangeSamlToken(this.token);
      },
      error => this.onAuthenticateError(error)
    );
  }

  /**
   * Uses the saml token to authenticate the user
   * @param samlToken
   */
  private exchangeSamlToken(samlToken: string): void {
    this.samlLoginService.getAccessToken(samlToken).subscribe(
      () => {
        this.message = LoginMessagesEnum.AUTHENTICATION_SUCCESS;
        this.navigateAfterTimeout(this.meUrl);
      },
      error => this.onExchangeSamlTokenError(error)
    );
  }

  private onAuthenticateError(error): void {
    // The user is not authenticated to saml
    if (error.error.code === "unauthenticated_pwc_user") {
      this.message = LoginMessagesEnum.REDIRECT;
      this.navigateAfterTimeout(this.samlUrl + "/saml/login");
      return;
    }

    this.onMysteriousError("authenticate", error);
  }

  private onExchangeSamlTokenError(error): void {
    // Handle concurrent login error
    if (error.status === 409
      && error.error
      && error.error.error === "concurrent_login_detected"
    ) {
      this.error = true;
      this.concurrentLogin = true;
      this.message = LoginErrorEnum.CONCURRENT_SESSION;
      return;
    }

    this.onMysteriousError("exchangeSamlToken", error);
  }

  // Something mysterious happened
  private onMysteriousError(methodName: string, error: any): void {
    this.error = true;
    this.message = LoginErrorEnum.GENERIC_ERROR;

    console.error({
      methodName: methodName,
      error: error
    });
  }

  private navigateAfterTimeout(url: string) {
    setTimeout(() => this.redirectService.navigate(url), 1000);
  }

  onContinueLogin(): void {
    this.message = LoginMessagesEnum.AUTHENTICATION;
    this.error = false;
    this.concurrentLogin = false;
    this.exchangeSamlToken(this.token);
  }

  onRetryLogin(): void {
    this.message = LoginMessagesEnum.AUTHENTICATION;
    this.error = false;
    this.concurrentLogin = false;
    this.authenticate();
  }

  onReturnLoginPage(): void {
    this.redirectService.navigate(this.meUrl + "/login");
  }

  goToHelpDesk(): void {
      this.router.navigate([RoutePath.LOGIN, RoutePath.FAQ, RoutePath.HELPDESK])
    }
}
